import { checkAnyErrorForPath, cn, retrieveErrorForPath } from "../../../shared/utils";
import SignatureInput from "../raw-inputs/signature-input.jsx";
import { Field, FieldError } from "../../ui/field";
import PropTypes from "prop-types";

/** SignatureInputBox - Migrated to shadcn Field component (Phase 2 - 2025-10-29) */
export default function SignatureInputBox({
    value,
    name,
    errors,
    handleChange,
    customErrorStyles,
    customInputWrapStyles,
    customFieldWrapStyles,
    label,
    disabled,
}) {
    const hasError = checkAnyErrorForPath(name, errors);
    const errorMessage = retrieveErrorForPath(name, errors);

    return (
        <Field
            className={cn("w-full rounded-md p-2", customFieldWrapStyles)}
            data-invalid={hasError}
            data-disabled={disabled}
        >
            <div
                className={cn(
                    "flex w-full flex-col rounded-lg border-[3px] border-gray-300 bg-white px-2 shadow-2xl",
                    "transition-colors duration-300",
                    hasError && "border-red-600",
                    customInputWrapStyles
                )}
            >
                <SignatureInput
                    name={name}
                    label={label}
                    value={value}
                    handleChange={handleChange}
                    disabled={disabled}
                />
            </div>
            {hasError && errorMessage && (
                <FieldError className={cn("text-destructive text-sm", customErrorStyles)}>
                    {errorMessage}
                </FieldError>
            )}
        </Field>
    );
}
SignatureInputBox.propTypes = {
    value: PropTypes.string,
    errors: PropTypes.object,
    disabled: PropTypes.bool,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    customErrorStyles: PropTypes.string,
    handleChange: PropTypes.func.isRequired,
    customInputWrapStyles: PropTypes.string,
    customFieldWrapStyles: PropTypes.string,
};
